// extracted by mini-css-extract-plugin
export var wordContainer = "_nw-0";